import * as React from "react";

function SvgGrupo2661(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
      <g data-name="Grupo 2661" transform="translate(14754 -11200)">
        <rect
          data-name="Ret\xE2ngulo 1446"
          width={32}
          height={32}
          rx={5}
          fill="#6c7485"
        />
        <g
          data-name="Grupo 2660"
          fill="#6c7485"
          stroke="#6c7485"
          strokeWidth={0.8}
        >
          <path
            data-name="Caminho 587"
            d="M-14733.431 11211.354l-.948 10.937h-6.957l-.949-10.937-1.2.107.964 11.13a1.02 1.02 0 001 .915h7.32a1.022 1.022 0 001-.923l.972-11.122z"
          />
          <path
            data-name="Caminho 588"
            d="M-14735.641 11208.342h-4.433a1.013 1.013 0 00-1.008 1.017v1.932h1.209v-1.729h4.03v1.729h1.209v-1.932a1.013 1.013 0 00-1.007-1.017z"
          />
          <path
            data-name="Caminho 589"
            d="M-14731.419 11211.355h-12.876a.61.61 0 000 1.22h12.876a.61.61 0 000-1.22z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgGrupo2661;

